<script>
  import MediaQuery from "../../components/MediaQuery.svelte";
  import { link } from "svelte-spa-router";
</script>

<footer>
  <MediaQuery query="(max-width: 550px)" let:matches>
    <!-- Mobile -->
    {#if matches}
      <div class="logo-img">
        <img src="./assets/images/logo.png" alt="Learning Lab" />
      </div>
    {/if}
  </MediaQuery>
  <div class="wrapper">
    <MediaQuery query="(min-width: 1281px)" let:matches>
      <!-- Desktop -->
      {#if matches}
        <div class="spacer" />
      {/if}
    </MediaQuery>
    <a href="/security" use:link>Security</a>
    <a href="/terms-of-use" use:link class="middle">Terms of use</a>
    <a href="/privacy-policy" use:link>Privacy Policy</a>
  </div>
</footer>

<style>
  footer {
    position: relative;
    max-width: 1440px;
    height: 180px;

    left: 0px;
    top: 355px;
  }

  a {
    cursor: pointer;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-decoration: none;
    color: inherit;
  }

  a:hover {
    transform: scale(0.97);
    text-decoration: underline;
  }

  .wrapper {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .middle {
    margin-left: 80px;
    margin-right: 80px;
  }

  a:last-of-type {
    margin-right: 62px;
  }

  .spacer {
    flex: 1;
  }

  @media (max-width: 1100px) {
    /* Tablets */
  }

  @media (max-width: 1280px) {
    /* Phones */

    footer {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .wrapper {
      width: 100%;
      margin-top: 40px;
      margin-bottom: 24px;
      height: 40px;
      display: flex;
      justify-content: space-evenly;
    }

    a {
      white-space: nowrap;
    }

    .middle {
      margin-left: 52px;
      margin-right: 52px;
    }

    a:last-of-type {
      margin-right: 0;
    }

    .logo-img {
      margin-top: 56px;
      width: 175px;
      height: 43px;
    }
  }
</style>
